import { FunctionComponent, PropsWithChildren } from "react";
import { FontWeights, Heading, Tile, useTheme } from "@bps/fluent-ui";

interface CategorySetTileProps {
  name: string;
}
export const CategorySetTile: FunctionComponent<PropsWithChildren<
  CategorySetTileProps
>> = ({ name, children }) => {
  const theme = useTheme();
  return (
    <Tile
      key={name}
      header={
        <Heading
          variant="section-heading-light"
          styles={{
            root: {
              color: theme.palette.themePrimary,
              fontWeight: FontWeights.semibold
            }
          }}
        >
          {name}
        </Heading>
      }
      styles={{
        root: { padding: 16 },
        header: { marginBottom: 24 }
      }}
      children={children}
    />
  );
};
